export default __webpack_public_path__ + "static/media/nexusTraining.b8dd60ea.svg";